import { gql } from 'apollo-angular';

const GET_PLAN_STATUS = gql`
  query getPlanDetailsOrPlanTaxByPlanId($planId: String!) {
   getPlanDetailsOrPlanTaxByPlanId(planId: $planId) {
    planId
    planName
    planLifeCycle {
      planStatus
    }
   }
  }
`
export { GET_PLAN_STATUS };
